import { createContext } from 'react';

const initialContext = [{}, () => {}];
export const uiStore = createContext(initialContext);
export default uiStore.Provider;
